import classNames from 'classnames';
import React, { ReactNode } from 'react';

import OfficeIcon from '@mui/icons-material/Domain';
import FaxIcon from '@mui/icons-material/FaxOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import PhoneIcon from '@mui/icons-material/PhoneIphone';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import StarIcon from '@mui/icons-material/Star';
import { makeStyles } from '@mui/styles';

import { PhoneType } from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';
import { format } from '@vestahealthcare/common/utils/phone';

import { CopyIcon } from '../CopyIcon';
import { Tooltip } from '../Tooltip';

type Props = {
  className?: string;
  compact?: boolean;
  hidePrimary?: boolean;
  icon?: ReactNode;
  phone: string;
  primary?: boolean;
  readOnly?: boolean;
  type?: string;
};

const useStyles = makeStyles({
  container: {
    height: 'fit-content',
  },
  copyIcon: {
    '&&': {
      padding: '0.25rem 0.5rem',
    },
  },
  small: {
    fontSize: '0.875em',
  },
});

const getPhoneIcon = (type?: string) => {
  const upperType = type?.toLocaleUpperCase();
  let icon = <QuestionMarkIcon color="action" />;
  if (upperType === PhoneType.BUSINESS.toString().toLocaleUpperCase())
    icon = <OfficeIcon color="action" />;
  if (upperType === PhoneType.HOME.toString().toLocaleUpperCase())
    icon = <HomeIcon color="action" />;
  if (upperType === PhoneType.CELL.toString().toLocaleUpperCase())
    icon = <PhoneIcon color="action" />;
  if (upperType === PhoneType.FAX.toString().toLocaleUpperCase())
    icon = <FaxIcon color="action" />;

  return <Tooltip text={type || 'Unknwon'}>{icon}</Tooltip>;
};

export const PhoneLink = ({
  className,
  compact,
  hidePrimary,
  icon,
  phone,
  primary,
  readOnly,
  type,
}: Props) => {
  const styles = useStyles();

  return (
    <div
      className={classNames(className, styles.container, 'flex middle wrap')}
    >
      {type && compact && !hidePrimary && (
        <>
          {primary ? (
            <Tooltip text="Primary Phone">
              <StarIcon fontSize="small" color={readOnly ? 'action' : 'info'} />
            </Tooltip>
          ) : (
            <div style={{ padding: '0 7px' }} />
          )}
        </>
      )}
      {type && compact && <>{getPhoneIcon(type)}&nbsp;</>}
      {readOnly ? (
        <span className={styles.small}>{format(phone)} </span>
      ) : (
        <a className={styles.small} href={`tel:${phone}`}>
          {format(phone)}{' '}
        </a>
      )}
      {!readOnly && (
        <CopyIcon
          className={styles.copyIcon}
          copyLabel={translate('global.copyPhone')}
          value={phone}
          size="small"
        />
      )}

      {!compact && primary && (
        <>
          &nbsp;
          <Tooltip text="Primary Phone">
            <StarIcon fontSize="small" color={readOnly ? 'action' : 'info'} />
          </Tooltip>
        </>
      )}
      {!compact && type && (
        <span className={styles.small} style={{ marginTop: '0.125rem' }}>
          {type}
        </span>
      )}
      {icon}
    </div>
  );
};
